import {baseUrl} from "./ApiEndpoints";
import {ApiService} from "./http/FederateApi.service";

export class SitesApiService extends ApiService {

    constructor() {
        super({
            baseUrl
        })
    }

    private urls = {
        sites: "/sites"
    }

    querySites(queryTerm: string) {
        console.log(`Querying sites with term: ${queryTerm}`);
        const url = `${this.urls.sites}/${queryTerm}`;
        console.log(`API Request URL: ${url}`);
        
        return super.get(url)
            .then(response => {
                console.log(`API Response raw for site query:`, response);
                
                // Check if response is wrapped in a data object
                if (response && response.data) {
                    console.log(`API Response unwrapped for site query:`, response.data);
                    return response.data; // Return unwrapped data
                }
                
                return response;
            })
            .catch(error => {
                console.error(`API Error for site query:`, error);
                throw error;
            });
    }
}
